<ic-loading-bar />

<ic-navigation
  data-qa="navigation.sections.list"
  [qaNodes]="menuQa"
  [appearance]="navigationAppearance()"
  [mode]="isScreenSmall() ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="menu()"
  [opened]="!isScreenSmall()" />

<ic-app-frame
  [legacyWrapper]="isLegacyRoute()"
  (toggle)="topBarToggle('mainNavigation')">
  <router-outlet />
</ic-app-frame>
